import { useState } from 'react';
import { cn } from 'helpers/cn';
import { FOCUS_RING } from '../../Dashboard/ConsolePanel';

const FAQS = [
  {
    question: 'What happens when the trial ends?',
    answer:
      'Your card is charged for the plan you picked, on the date shown. You can cancel or switch plan from Settings, Billing, any time before then.',
  },
  {
    question: 'What counts as a session?',
    answer: 'One browser tab on a website running the Pertento tracker, counted once however many pages it visits.',
  },
  {
    question: 'What if I go over my sessions?',
    answer:
      'Your experiments keep running. You get a notice at 80% and at 100% of your plan, and one month over is free. Two months over in a row, or three times your sessions in one month, moves you up one plan from the next period. You are told first and can choose Keep my plan.',
  },
  {
    question: 'Can I change plan later?',
    answer:
      'Yes, from Settings. Upgrades apply immediately and the difference is charged, prorated. Downgrades apply at the next billing date.',
  },
] as const;

/** "Before you start": one answer open at a time, all closed to begin with. */
export const PlanFaq = () => {
  const [open, setOpen] = useState(-1);

  return (
    <section className="flex flex-col gap-3 pt-3">
      <span className="micro-label">Before you start</span>
      <div className="border-line flex flex-col overflow-hidden rounded-xl border">
        {FAQS.map((faq, index) => (
          <div key={faq.question} className={index === 0 ? '' : 'border-line border-t'}>
            <button
              type="button"
              aria-expanded={open === index}
              onClick={() => setOpen(open === index ? -1 : index)}
              className={cn(
                'text-foreground hover:bg-hover flex w-full cursor-pointer items-center justify-between gap-4 px-3.5 py-3 text-left text-[13px] transition-colors duration-150',
                FOCUS_RING,
              )}
            >
              <span>{faq.question}</span>
              <span className="text-dim font-mono" aria-hidden="true">
                {open === index ? '−' : '+'}
              </span>
            </button>
            {open === index && (
              <p className="text-dim m-0 max-w-[72ch] px-3.5 pb-3.5 text-micro leading-[1.55]">{faq.answer}</p>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};
